import React from "react";
import CropJpgFaq from "./CropJpgFaq";
import CropJpgFreeContent from "./CropJpgFreeContent";
import { CropJpgFreeWithOnline } from "./CropJpgFreeWithOnline";

const CropJpgPreToolsArea = () => {
    return (
        <div className="flex justify-center items-center-center content-center">
            <div className="max-w-4xl mx-5  md:mx-20">
                <CropJpgFreeWithOnline />
                <CropJpgFreeContent />
                <CropJpgFaq />
            </div>
        </div>
    );
};

export default CropJpgPreToolsArea;
